module.exports = __webpack_public_path__ + "static/logo_RockOrg_white_main-a709b6586ba49aa8be30658df52348f1.png";